import { Button } from '@material-tailwind/react';
import { getIcon } from '../../utils/helper';
import { IconButton } from '@mui/material';

const ButtonUI = (props) => {
  const { text, icon, ...otherProps } = props;

  return (
    <Button {...otherProps}>
      {icon && <IconButton sx={{ m: 0, p: 0, mr: 0.5 }}>{getIcon(icon, '1rem', 'white')}</IconButton>}
      {text}
    </Button>
  );
};

export default ButtonUI;
